import { Component, OnInit, OnChanges, Input, ViewChild, ViewChildren, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DealerInfo } from '../../../api/models/dealer-info';
import { ErrorMessage } from '../../../api/models/error-message';
import { Subject } from 'rxjs/Subject';
import { UserProfile } from '../../../api/models/user-profile';
import { WpAjaxService } from '../../services/wp-ajax/wp-ajax.service';
import { CookieHelperService } from '../../services/cookie-helper.service';
import { scheduleDateValidator } from './schedule-date.validator';
import { takeUntil } from 'rxjs/operators';
import * as $ from 'jquery';
import { ELEMENT_PROBE_PROVIDERS } from '@angular/platform-browser/src/dom/debug/ng_probe';

import { DatePipe } from '@angular/common';
import { UserDetails } from '../../../api/models/user-details';

@Component({
  selector: 'app-schedule-appointment',
  templateUrl: './schedule-appointment.component.html',
  styleUrls: ['./schedule-appointment.component.scss']
})
export class ScheduleAppointmentComponent implements OnInit, OnChanges {

    private datePipe: DatePipe = new DatePipe('en-us');

    modalHide = false;
    date: Date;
    minDate: Date;
    minTime: Date;
    appointmentForm: FormGroup;
    isSubmitted = false;
    isSubmitting = false;
    selectedDealer: DealerInfo = null;
    selectedDealerId = 1;
    dropdownDealerItems: any = [];
    errorMessage: ErrorMessage;
    bgColor: string;
    _data_object = (<any>window)._WFSDirect_Object;
    datePickerConfig: any = {};
    datePickerConfigMask: any = {};

    private _subject = new Subject<void>();

    @Input() dealers: DealerInfo[];
    @Input() userProfile: UserDetails;

    @ViewChildren('input') vc: ElementRef;
    @ViewChild('btnClose') btnClose: ElementRef;

    get emptyDealer(): boolean {
        if (this.dealers === undefined || this.dealers === null) {
            return true;
        }
        return this.dealers.length === 0;
    }

    constructor(
        private fb: FormBuilder,
        private ajax: WpAjaxService,
        private cookieService: CookieHelperService,
        private cd: ChangeDetectorRef
    ) {
        this.date = new Date();
    }

    ngOnChanges() {
        this.setInitData();
    }

    ngOnInit() {
        /**
         * Disabled past dates
         * **/
        const currentYear = this.date.getFullYear();
        const currentMonth = this.date.getMonth();
        const currentDate = this.date.getDate();

        this.minDate = new Date(currentYear, currentMonth, currentDate, 0, 0);
        this.minTime = new Date(currentYear, currentMonth, currentDate, 10, 0);

        /**
         * Initialize datepicker props
         */
        this.datePickerConfig = {
            minDate: 0,
            format: 'm/d/Y',
            timepicker: false
        };

        this.datePickerConfigMask = {
            mask: '99/99/9999'
        };

        /**
         * todo: Add handler if no dealer for the given zipcode
         */
        this.AppointmentForm();
    }

    modalShow() {
        // Add current date as starting value to date field
        this.modalHide = true;
        this.errorMessage = {
            show: false
        };
    }

    isFieldValid(field: string) {
        let valid;
        valid =  this.appointmentForm.get(field).valid;
        return (this.isSubmitted && !valid);

    }

    ErrorMessage() {
        const emailField = this.appointmentForm.controls.emailAddress.errors;
        const emailInvalid = (emailField != null) ? emailField.email : true;
        const emailRequired = (emailField != null) ? emailField.required : true;
        let errorMsg = '';
        if (emailInvalid && !emailRequired) {
            errorMsg =  'Please input valid email.';
        } else {
            errorMsg = 'Please complete the required fields.';
        }

        const schedule = this.appointmentForm.get('schedule');
        if (schedule.errors) {
            if ('invalidSchedule' in schedule.errors) {
                errorMsg = 'Invalid date and time input.';
            }
        }

        if (!this.appointmentForm.get('schedule.appointmentTime').valid) {
            errorMsg = 'Invalid input.';
        }
        this.errorMessage = {
            show: true,
            message: errorMsg
        };
    }

    AppointmentForm() {

        this.appointmentForm =  this.fb.group({
            firstName:  ['',  Validators.required],
            lastName:  ['',  Validators.required],
            phoneNumber:  ['',  Validators.required],
            emailAddress:  ['',  [Validators.required,  Validators.email]],
            schedule: this.fb.group({
                month: ['', [Validators.required]],
                day: ['', [Validators.required]],
                year: ['', [Validators.required]],
                appointmentTime: [this.minTime, Validators.required]
            }, { validator: scheduleDateValidator }),
            dealer: ['', Validators.required]
        });

    }

    onSubmit(evt) {
        this.isSubmitted = true;
        if (this.appointmentForm.valid) {
            this.submitAppointment();
        } else {
            this.ErrorMessage();
            this.bgColor = '';
        }

    }

    submitAppointment() {
        this.isSubmitting = true;

        this.ajax
            .post_request({
                request_type: 'scheduleAppointment',
                DealId: this.userProfile.DealID,
                privacyPolicyConsent: true,
                marketingConsent: this.userProfile.MarketingConsentFlag,
                DealerContactName: `${this.appointmentForm.get('firstName').value} ${this.appointmentForm.get('lastName').value}`,
                DealerContactPhone: this.appointmentForm.get('phoneNumber').value,
                DealerContactEmail: this.appointmentForm.get('emailAddress').value,
                DealerOrder: this.selectedDealerId,
                TestDriveAppt: `${this.getAppointmentDate()} ${this.getAppointmentTime()}`,
                DealerName: this.selectedDealer.dealerName,
                DealerPhone: this.selectedDealer.dealerPhone,
                DealerAddress: this.selectedDealer.dealerAddress,
                DealerState: this.selectedDealer.dealerState,
                DealerCity: this.selectedDealer.dealerCity,
                DealerZip:  this.selectedDealer.dealerZip,
            })
            .pipe(takeUntil(this._subject))
            .subscribe(
                response => {
                    if (response.success) {
                        this.selectedDealerId = 1;
                        this.cd.markForCheck();
                        this.isSubmitting = false;
                        this.appointmentForm.reset();
                        this.setFormUserProfile();
                        this.bgColor = 'green';
                        this.btnClose.nativeElement.click();
                        this.errorMessage = {
                            show: true,
                            message: response.data.Description
                        };
                    }
                },
                error => {
                    console.log(error);
                }
            );
    }

    dealerChange(data, e) {
        this.selectedDealer = this.dealers[data.index];
        this.selectedDealerId = data.index + 1;
    }

    setInitData() {
        if (this.dealers.length > 0 && this.selectedDealer === null) {
            this.selectedDealer = this.dealers[0];
            this.appointmentForm.get('dealer').setValue(this.dealers[0].dealerName);
            this.makeDealerDropdownItems();
        }
        if (this.userProfile) {
            this.setFormUserProfile();
        }
    }

    makeDealerDropdownItems() {
        this.dealers.forEach(dealer => {
            this.dropdownDealerItems.push({
                Name: dealer.dealerName
            });
        });
    }

    private setFormUserProfile(): void {
        let dealerName = '';
        if (this.dealers.length > 0) {
            dealerName = this.dealers[0].dealerName;
            this.selectedDealer = this.dealers[0];
        }
        this.appointmentForm.get('dealer').setValue(dealerName);
        this.appointmentForm.get('firstName').setValue(this.userProfile.FirstName);
        this.appointmentForm.get('lastName').setValue(this.userProfile.LastName);
        this.appointmentForm.get('phoneNumber').setValue(this.userProfile.HomePhone);
        this.appointmentForm.get('emailAddress').setValue(this.userProfile.Email);

        const schedMonth = (new Date()).getMonth() + 1;
        const month = (schedMonth < 9) ? `0${schedMonth}` : schedMonth;
        this.appointmentForm.get('schedule.month').setValue(month);
        this.appointmentForm.get('schedule.day').setValue((new Date()).getDate());
        this.appointmentForm.get('schedule.year').setValue((new Date()).getFullYear());

        const currentYear = this.date.getFullYear();
        const currentMonth = this.date.getMonth() + 1;
        const currentDate = this.date.getDate();

        this.minTime = new Date(currentYear, currentMonth, currentDate, 10, 0);
    }

    private getAppointmentDate() {
        const month = this.appointmentForm.get('schedule.month').value;
        const day = this.appointmentForm.get('schedule.day').value;
        const year = this.appointmentForm.get('schedule.year').value;
        const inputDate = new Date(`${year}/${month}/${day}`);
        return `${inputDate.getFullYear()}-${inputDate.getMonth() + 1}-${inputDate.getDate()}`;
    }

    private getAppointmentTime() {
        const inputDate = new Date(this.appointmentForm.get('schedule.appointmentTime').value);
        const hour = inputDate.getHours();
        const meridian = hour >= 12 ? 'PM' : 'AM';
        return `${inputDate.getHours()}:${inputDate.getUTCMinutes()} ${meridian}`;
    }

    onKeyDownDatePicker(event) {
        const charCode = event.charCode ? event.charCode : event.which;
        if (charCode === 13) {
            let elem: any = $(event.target).parent().next('div').find('input');
            if (elem.length > 1) {
                elem = elem[0];
            }
            elem.focus();
            elem.setSelectionRange(0, 0);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/schedule-appointment/schedule-appointment.component.ts